import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar-seller',
  templateUrl: './progress-bar-seller.component.html',
  styleUrls: ['./progress-bar-seller.component.scss']
})
export class ProgressBarSellerComponent implements OnInit {
  @Input() active?: any;
  steps = [
      'Αποδοχή Αίτησης',
      'Επιλογή Ακινήτων προς Μεταβίβαση',
      'Παρακολούθηση Υποβληθείσας Αίτησης',
  ];
  constructor() {}

  ngOnInit(): void {
      if (!this.active) {
          this.active = 4;
      }
  }
}
